import { installRandomUuidPolyfill } from './lib/random-uuid.js';

/**
 * Runs on import so `boot.tsx` can load it first, before any module that might call
 * `crypto.randomUUID()` is evaluated. See `installRandomUuidPolyfill` for why it exists.
 */
installRandomUuidPolyfill();
